<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">
    <!-- Header & Cards -->
    <div class="relative pt-8 pb-12 sm:pt-20 sm:pb-24 px-6 sm:px-16 overflow-hidden" *ngIf="configured">
        <!-- Background - @formatter:off -->
        <svg class="-z-1 absolute inset-0" viewBox="0 0 960 540" width="100%" height="100%"
            preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="opacity-40 text-gray-200 dark:text-gray-800" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- @formatter:on -->
        <!-- Header -->
        <div class="flex flex-col items-center">
            <h2 class="text-xl font-semibold">PAQUETES</h2>
            <div class="mt-1 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight text-center">
                No te quedes sin facturar
            </div>
            <div class="mt-3 sm:text-2xl text-center tracking-tight text-secondary">
                <div class="">Selecciona el paquete de tú conveniencia.</div>
                <div class="">Contáctanos para confirmar.</div>
            </div>
        </div>
        <!-- Cards -->
        <div class="flex justify-center mt-10 sm:mt-20">
            <div class="w-full max-w-sm md:max-w-7xl">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 lg:gap-y-0 md:gap-x-6">
                    <ng-container *ngFor="let item of paquetes">
                        <!-- Card 1 -->
                        <fuse-card class="flex-col max-w-sm md:max-w-none p-6 sm:py-12 sm:px-10" *ngIf="!item.attributes.popular">
                            <div class="text-4xl font-bold tracking-tight leading-tight">{{ item.attributes.paquete }}</div>
                            <div class="mt-2 text-lg font-medium tracking-tight text-secondary">{{ item.attributes.descripcion }}
                            </div>
                            <div class="w-8 h-1 my-10 rounded bg-accent"></div>
                            <!-- Price -->
                            <div class="flex items-baseline whitespace-nowrap">
                                <div class="mr-2 text-2xl">MXN</div>
                                <div class="text-6xl font-semibold leading-tight tracking-tight">
                                    <ng-container>{{ item.attributes.precio | currency }}</ng-container>
                                </div>
                            </div>
                            <!-- Price details -->
                            <div class="flex flex-col mt-2 text-secondary">
                                <div><b>{{ (item.attributes.precio / item.attributes.folios) | currency }}</b> por folio</div>
                            </div>
                            <!-- CTA -->
                            <button class="fuse-mat-button-large mt-10" mat-stroked-button
                                (click)="openDialog(item)"
                                [color]="'primary'">
                                Solicítalo ahora
                            </button>
                            <!-- Features -->
                            <div class="flex flex-col mt-12">
                                <div class="font-semibold">Incluye:</div>
                                <div class="mt-4 space-y-2">
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5"><b>1</b> año de vigencia</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5"><b>{{ item.attributes.folios }}</b> folios</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Multiples usuarios</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Soporte por correo</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Envío de facturas a clientes</div>
                                    </div>
                                    <!-- <div class="flex">
                                        <mat-icon
                                            class="icon-size-5 text-green-600"
                                            svgIcon="heroicons_solid:check"></mat-icon>
                                        <div class="ml-2 leading-5">Free mobile app</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon
                                            class="icon-size-5 text-green-600"
                                            svgIcon="heroicons_solid:check"></mat-icon>
                                        <div class="ml-2 leading-5">Access to forums</div>
                                    </div> -->
                                </div>
                            </div>
                        </fuse-card>

                        <fuse-card
                            class="flex-col max-w-sm md:max-w-none p-6 sm:py-12 sm:px-10 ring-2 ring-primary overflow-visible"
                            *ngIf="item.attributes.popular">
                            <div class="absolute inset-x-0 -top-4 flex items-center justify-center">
                                <div
                                    class="flex items-center h-8 px-8 rounded-full font-medium text-center leading-none bg-primary text-on-primary">
                                    Más comprado</div>
                            </div>
                            <div class="text-4xl font-bold tracking-tight leading-tight">{{ item.attributes.paquete }}</div>
                            <div class="mt-2 text-lg font-medium tracking-tight text-secondary">{{ item.attributes.descripcion }}
                            </div>
                            <div class="w-8 h-1 my-10 rounded bg-accent"></div>
                            <!-- Price -->
                            <div class="flex items-baseline whitespace-nowrap">
                                <div class="mr-2 text-2xl">MXN</div>
                                <div class="text-6xl font-semibold leading-tight tracking-tight">
                                    <ng-container>{{ item.attributes.precio | currency }}</ng-container>
                                </div>
                            </div>
                            <!-- Price details -->
                            <div class="flex flex-col mt-2 text-secondary">
                                <ng-container>
                                    <!-- <div>billed yearly</div> -->
                                    <div><b>{{ (item.attributes.precio / item.attributes.folios) | currency }}</b> por folio</div>
                                </ng-container>
                            </div>
                            <!-- CTA -->
                            <button class="fuse-mat-button-large mt-10" mat-flat-button
                                (click)="openDialog(item)"
                                [color]="'primary'">
                                Solicítalo ahora
                            </button>
                            <!-- Features -->
                            <div class="flex flex-col mt-12">
                                <div class="font-semibold">Incluye:</div>
                                <div class="mt-4 space-y-2">
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5"><b>1</b> año de vigencia</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5"><b>{{ item.attributes.folios }}</b> folios</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Multiples usuarios</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Soporte por correo</div>
                                    </div>

                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" svgIcon="heroicons_solid:check">
                                        </mat-icon>
                                        <div class="ml-2 leading-5">Envío de facturas a clientes</div>
                                    </div>
                                    <!-- <div class="flex">
                                        <mat-icon
                                            class="icon-size-5 text-green-600"
                                            svgIcon="heroicons_solid:check"></mat-icon>
                                        <div class="ml-2 leading-5">Free mobile app</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon
                                            class="icon-size-5 text-green-600"
                                            svgIcon="heroicons_solid:check"></mat-icon>
                                        <div class="ml-2 leading-5">Access to forums</div>
                                    </div> -->
                                </div>
                            </div>
                        </fuse-card>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!configured">
        <div class="relative pt-8 pb-12 sm:pt-20 sm:pb-24 px-6 sm:px-16 overflow-hidden">
            <div class="card p-4 mt-3" *ngIf="!configured">
                <!-- Icon Section -->
                <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4" style="width: 60px; height: 60px; margin: 0 auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path>
                    </svg>
                </div>
            
                <!-- Title Section -->
                <h5 class="card-title text-center">Emisor Requerido</h5>
            
                <!-- Description Section -->
                <p class="card-text text-secondary text-center">
                    Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
                </p>
            
                <!-- Button Section -->
                <div class="text-center mt-4">
                    <a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
                </div>
            </div>
        </div>
    </div>
</div>